
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const OficinasEnRenta = lazy(() => import('../pages/landing/OficinasEnRenta'));
const OficinasAAAMerida = lazy(() => import('../pages/landing/OficinasAAA'));
const LocalesComerciales = lazy(() => import('../pages/landing/LocalesComerciales'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/oficinas-en-renta',
    element: <OficinasEnRenta />
  },
  {
    path: '/oficinas-aaa-merida',
    element: <OficinasAAAMerida />
  },
  {
    path: '/locales-comerciales',
    element: <LocalesComerciales />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
